import { IonCol, IonGrid, IonIcon, IonListHeader, IonRow } from '@ionic/react';
import React from 'react';

import { chevronForward } from 'ionicons/icons';

import './UserMenuSection.scss';
import { UserMenuSectionProps } from './types';

const UserMenuSection: React.FC<UserMenuSectionProps> = ({ title, items }) => {
  if (!items.length) return null;

  return (
    <div className="user-menu-section">
      <IonListHeader>{title}</IonListHeader>

      <IonGrid className="ion-no-padding">
        {items.map(({ label, icon, onClick, hidden }, i) => (
          <IonRow
            key={`${title}-${i}`}
            onClick={onClick}
            className={i !== items.length - 1 ? 'aux-border-bottom' : undefined}
            hidden={hidden}
          >
            <IonCol size="1" offset="0.25">
              {icon}
            </IonCol>

            <IonCol offset="0.75" className="btn-label">
              {label}
            </IonCol>

            <IonCol size="1" offset="0.5">
              <IonIcon icon={chevronForward} />
            </IonCol>
          </IonRow>
        ))}
      </IonGrid>
    </div>
  );
};

export default UserMenuSection;
